import { getUnique } from "@/utils/number/unique";

export function SkillModel(data) {
    const model = {
        unique: getUnique(),
        value: null,
        level: null,
    };

    if (!data) {
        return model;
    }

    const { value, level } = data;

    if (value) {
        const { id, text, custom } = value;
        model.value = {
            value: `${id}`,
            label: `${text}`,
            custom,
        };
    }

    if (level) {
        const { id, text, custom } = level;
        model.level = {
            value: `${id}`,
            label: `${text}`,
            custom,
        };
    }

    return model;
}

export function isEmptySkill(data) {
    const { value, level } = data;
    return !value || !level;
}

export function formatSkillModel(data) {
    const result = {
        value: null,
        level: null,
    };

    const { value: skillValue, level } = data;

    if (skillValue) {
        const { value, label, custom } = skillValue;
        result.value = {
            id: custom ? label : value,
            text: label,
            custom,
        };
    }

    if (level) {
        const { value, label, custom } = level;
        result.level = {
            id: custom ? label : value,
            text: label,
            custom,
        };
    }

    return result;
}
